export default [{
	titulo: 'Prefeitos',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/prefeitos',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]